import { extendTheme } from '@mui/joy/styles';

const whatsappPrimary = {
  50: '#e8f8ec',
  100: '#c5efd0',
  200: '#9ee3ac',
  300: '#6dd484',
  400: '#3fc55d',
  500: '#25D366',
  600: '#1da855',
  700: '#167d41',
  800: '#0f532b',
  900: '#082916',
} as const;

export const joyAppTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: whatsappPrimary,
      },
    },
    dark: {
      palette: {
        primary: {
          50: '#082916',
          100: '#0f532b',
          200: '#167d41',
          300: '#1da855',
          400: '#25D366',
          500: '#3fc55d',
          600: '#6dd484',
          700: '#9ee3ac',
          800: '#c5efd0',
          900: '#e8f8ec',
        },
      },
    },
  },
});
